import Alpine from 'alpinejs'

function getElementProperty(el, property){
    return window.getComputedStyle(el).getPropertyValue(property);
}

Alpine.data('sidebar', () => ({
    opened: false,
    init(){
        let [ sidebar ] = document.getElementsByClassName('sidebar');
        let position = getElementProperty(sidebar, 'position');
        if(position == "relative" && this.opened === false){
            this.opened = true;
        }
    },
    open (){
        this.opened = true;
    },
    close (){
        this.opened = false;
    },
    toggle(){
        this.opened = !this.opened;
    },
    trigger: {
        ['@click']() { this.toggle() },
    },
}))

Alpine.start();

